// globalThis.__VUE_OPTIONS_API__ = true;
// globalThis.__VUE_PROD_DEVTOOLS__ = false;

import { createApp } from 'vue'
import VueGoogleMaps from "@fawmi/vue-google-maps";

import VueWooSearch from './VueWooSearch.vue';
import VueWhereToView from './VueWhereToView.vue';
import VueSalesManagerMap from './VueSalesManagerMap.vue';

const searchApp = createApp(VueWooSearch);
const salesManagerMapApp = createApp(VueSalesManagerMap);

const whereToViewApp = createApp(VueWhereToView)
	.use(VueGoogleMaps, {
	  load: {
	    key: "AIzaSyBv1OoJYBvAm53BKnOcc_nuV4ixeMQNWl8"
	  }
	});

if(document.getElementById('where-to-view-app')) {
	whereToViewApp.mount('#where-to-view-app');
}

if(document.getElementById('sales-manager-map-app')) {
	salesManagerMapApp.mount('#sales-manager-map-app')
}

if(document.getElementById('search-app')) {
	searchApp.mount('#search-app')
}
